import React, { Component, PropTypes } from 'react';

const PreviewElement = ({ fontData, text, className }) => {
    return (
        <div
            className={className}
            style={{
                fontFamily: fontData.font,
                textAlign: fontData.align,
                lineHeight: fontData.lineHeight,
                textDecoration: fontData.decoration,
                fontStyle: fontData.style,
                // color: fontData.color,
                fontWeight: fontData.weight,
                fontSize: fontData.size
            }}
        >
            {/* TODO  use real hotel names here */}
            {text}
        </div>
    );
};

PreviewElement.propTypes = {
    fontData: PropTypes.object,
    text: PropTypes.string,
    className: PropTypes.string
};

export default PreviewElement;



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/PreviewElement.js